import { ReactElement } from "react"

export function validateDisplayNameChild(
  child: ReactElement & { type: { displayName?: string } },
  displayName: string,
) {
  return child.type.displayName === displayName
}
